import { NgModule } from "@angular/core";
import { SharedApiKno2fyMainModule } from "@kno2/data-access/api-kno2fy-main";
import { SharedUtilConfigurationModule } from "@kno2/core/configuration";
import { SharedUtilIntegrationsModule } from "@kno2/core/integrations";
import { StoreModuleConfiguration } from "./store.module";
import { DesktopDataAccessApiDesktopModule } from "@kno2/data-access/api-desktop";
import { HTTP_INTERCEPTORS } from "@angular/common/http";
import { AuthInterceptor } from "./interceptors/auth.interceptor";

@NgModule({
    imports: [
        SharedUtilConfigurationModule,
        SharedApiKno2fyMainModule,
        StoreModuleConfiguration,
        SharedUtilIntegrationsModule,
        DesktopDataAccessApiDesktopModule
    ],
    providers: [
        {
            provide: HTTP_INTERCEPTORS,
            useClass: AuthInterceptor,
            multi: true
        }
    ]
})
export class CoreModule {}
